module.exports = __webpack_public_path__ + "img/back.0e918ced.jpg";